import React from "react";
import { motion } from "framer-motion";
import {
  Wrench,
  Eye,
  FileText,
  Award,
  Zap,
  Disc,
  Settings,
  Car,
  Wind,
  Thermometer,
  Shield,
  History,
  User,
  Clipboard,
  ShieldCheck,
  FileCheck,
  AlertTriangle,
  Plus,
} from "lucide-react";
import svCommon from "@/i18n/locales/sv/common.json";
import enCommon from "@/i18n/locales/en/common.json";

export const getTestAreas = (language: "sv" | "en") => {
  const common = language === "en" ? enCommon : svCommon;
  const testAreasData = common.menuPages?.sellCar?.testSection?.testAreas || [];

  const iconComponents = [
    <Wrench className="w-8 h-8 text-blue-500" />,
    <Eye className="w-8 h-8 text-green-500" />,
    <FileText className="w-8 h-8 text-purple-500" />,
    <Award className="w-8 h-8 text-orange-500" />,
  ];

  const itemIcons = [
    [Settings, Disc, Car, Zap, Wind],
    [Shield, AlertTriangle, Eye, Disc, Car],
    [Car, Zap, Thermometer, Shield, Plus],
    [History, User, Clipboard, ShieldCheck, FileCheck],
  ];

  const itemIconColors = [
    [
      "text-blue-600",
      "text-red-600",
      "text-gray-600",
      "text-yellow-600",
      "text-gray-500",
    ],
    [
      "text-blue-500",
      "text-orange-600",
      "text-cyan-500",
      "text-black",
      "text-gray-500",
    ],
    [
      "text-amber-600",
      "text-blue-600",
      "text-blue-400",
      "text-green-500",
      "text-purple-500",
    ],
    [
      "text-green-600",
      "text-blue-500",
      "text-green-500",
      "text-blue-600",
      "text-orange-500",
    ],
  ];

  return testAreasData.map((area: any, areaIndex: number) => {
    const IconComponent = iconComponents[areaIndex] || iconComponents[0];
    const icons = itemIcons[areaIndex] || itemIcons[0];
    const colors = itemIconColors[areaIndex] || itemIconColors[0];

    const items = (area.items || []).map((item: any, itemIndex: number) => {
      const ItemIcon = icons[itemIndex] || icons[0];
      return {
        text: item.text || "",
        icon: (
          <ItemIcon className={`w-4 h-4 ${colors[itemIndex] || colors[0]}`} />
        ),
        animation: item.animation || {},
      };
    });

    return {
      icon: IconComponent,
      title: area.title || "",
      items: items,
    };
  });
};
